/**
 * Product grid / collection card: AJAX add to cart + variant drawer (delegated events).
 * Depends on theme.js (theme.AjaxProduct, theme.strings).
 */
(function () {
  'use strict';

  function soldOutLabel() {
    return window.theme && theme.strings && theme.strings.soldOut
      ? theme.strings.soldOut
      : 'Sold out';
  }

  function bindGridVariantSelects(root) {
    root.querySelectorAll('.grid-product select.product-single__variants').forEach(function (selectEl) {
      if (selectEl.dataset.gridVariantSelectBound === 'true') return;
      selectEl.dataset.gridVariantSelectBound = 'true';
      selectEl.addEventListener('change', function () {
        var formEl = selectEl.closest('form');
        if (!formEl) return;
        var btn = formEl.querySelector('[data-add-to-cart]');
        var btnText = formEl.querySelector('[data-add-to-cart-text]');
        var opt = selectEl.selectedOptions[0];
        if (!btn || !btnText || !opt) return;
        // if (opt.disabled) {
        //   btn.disabled = true;
        //   btnText.textContent = soldOutLabel();
        //   return;
        // }
        // btn.disabled = false;
        // var def = btnText.getAttribute('data-default-text');
        // if (def) btnText.textContent = def;
      });
    });
  }

  function bindGridProductForms(root) {
    if (!window.theme || typeof theme.AjaxProduct !== 'function') return;

    root.querySelectorAll('.grid-product form.product-single__form').forEach(function (form) {
      if (form.dataset.ajaxProductBound === 'true') return;
      form.dataset.ajaxProductBound = 'true';

      /* Collection card ATC must always add 1 — qty UI can drift or mis-submit before AjaxProduct reads FormData */
      form.addEventListener(
        'submit',
        function gridCardForceQtyOne() {
          var qtyInput =
            form.querySelector('.product__quantity input[name="quantity"]') ||
            form.querySelector('input[name="quantity"]');
          if (qtyInput) qtyInput.value = '1';
        },
        true
      );

      try {
        new theme.AjaxProduct(form);
      } catch (e) {
        console.error('[grid-product-card] AjaxProduct init failed', e);
      }
    });

    bindGridVariantSelects(root);
  }

  function init(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    bindGridProductForms(root);
  }

  function toggleVariantWrappers(form, addActive) {
    if (!form) return;
    form.querySelectorAll('.variant-wrapper.js').forEach(function (w) {
      if (addActive) w.classList.add('active');
      else w.classList.remove('active');
    });
  }

  function openGridVariantPicker(btn) {
    var form = btn.closest('form');
    if (!form || !form.closest('.grid-product')) return;
    toggleVariantWrappers(form, true);
    document.body.classList.add('grid-product-card-variant-open');
    window.setTimeout(function () {
      btn.setAttribute('type', 'submit');
      btn.removeAttribute('data-grid-variant-open');
    }, 2000);
  }

  function closeGridVariantPicker(trigger) {
    var form = trigger.closest('form');
    if (!form) return;
    toggleVariantWrappers(form, false);
    document.body.classList.remove('grid-product-card-variant-open');
    var submitBtn = form.querySelector('button[name="add"][data-add-to-cart]');
    if (submitBtn) {
      submitBtn.setAttribute('type', 'button');
      submitBtn.setAttribute('data-grid-variant-open', '');
    }
  }

  function syncSelectFromVariantLabel(labelEl) {
    var vid = labelEl.getAttribute('data-grid-variant-id');
    var selId = labelEl.getAttribute('data-grid-select-id');
    if (!vid || !selId) return;
    var selectEl = document.getElementById(selId);
    if (!selectEl) return;
    var opts = Array.prototype.slice.call(selectEl.options);
    var idx = opts.findIndex(function (opt) {
      return String(opt.value) === String(vid);
    });
    if (idx === -1) return;
    selectEl.selectedIndex = idx;
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener(
    'click',
    function (e) {
      var gridRoot = e.target.closest('.grid-product');
      if (!gridRoot) return;

      var closeBtn = e.target.closest('[data-grid-variant-close]');
      if (closeBtn) {
        e.preventDefault();
        closeGridVariantPicker(closeBtn);
        return;
      }

      var openBtn = e.target.closest('[data-grid-variant-open]');
      if (openBtn && openBtn.matches('button.add-to-cart')) {
        e.preventDefault();
        openGridVariantPicker(openBtn);
        return;
      }

      var lab = e.target.closest('label[data-grid-variant-id]');
      if (lab && lab.closest('.grid-product')) {
        window.requestAnimationFrame(function () {
          syncSelectFromVariantLabel(lab);
        });
      }
    },
    false
  );

  function onReady() {
    init(document);
  }

  document.addEventListener('DOMContentLoaded', onReady);
  document.addEventListener('page:loaded', onReady);
  document.addEventListener('collection:reloaded', onReady);
  document.addEventListener('recommendations:loaded', function (evt) {
    if (evt.detail && evt.detail.section) init(evt.detail.section);
    else init(document);
  });
  document.addEventListener('shopify:section:load', function () {
    init(document);
  });
})();
